import { render } from "./autocomplete.vue?vue&type=template&id=8351e810&scoped=true"
import script from "./autocomplete.vue?vue&type=script&lang=js"
export * from "./autocomplete.vue?vue&type=script&lang=js"

import "./autocomplete.vue?vue&type=style&index=0&id=8351e810&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8351e810"
/* hot reload */
if (module.hot) {
  script.__hmrId = "8351e810"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8351e810', script)) {
    api.reload('8351e810', script)
  }
  
  module.hot.accept("./autocomplete.vue?vue&type=template&id=8351e810&scoped=true", () => {
    api.rerender('8351e810', render)
  })

}

script.__file = "src/components/autocomplete.vue"

export default script